import React, { KeyboardEvent, useState } from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";
import HomeIcon from "@mui/icons-material/Home";
import BackIcon from "@mui/icons-material/ArrowBack";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import SearchIcon from "@mui/icons-material/Search";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import useActions, { useAppDispatch, useAppSelector } from "../../../app/hooks";

import { grey } from "@mui/material/colors";
import { Checkbox, Divider, IconButton, InputAdornment, TextField } from "@mui/material";
import { openNetwork } from "../librarySlice";
import {
  selectFolderName,
  selectFolderNameStack,
  selectLibrary,
  selectRepoId,
  selectReposMode,
  selectRoleId,
  selectRolesMode,
  selectScenarioId,
  selectScenariosMode,
  setCodeSearchString,
  setFilterString,
  setFolderName,
  setRepoId,
  setReposMode,
  setRoleId,
  setRolesMode,
  setScenarioId,
  setScenariosMode,
  setSearchMode,
  setViewDeleted,
} from "../librarySlice";
import { selectCurrentWorkspace } from "../../auth/authSlice";

export function LibraryHeaderMenu() {
  const actions = useActions();
  const librarySlice = useAppSelector(selectLibrary);
  const folders = useAppSelector(selectFolderNameStack);
  const dispatch = useAppDispatch();

  const rolesMode = useAppSelector(
    selectRolesMode
  );

  const reposMode = useAppSelector(
    selectReposMode
  );

  const scenariosMode = useAppSelector(
    selectScenariosMode
  );

  const viewRoleId = useAppSelector(
    selectRoleId
  );

  const viewRepoId = useAppSelector(
    selectRepoId
  );

  const viewScenarioId = useAppSelector(
    selectScenarioId
  );

  const currentWorkspace = useAppSelector(selectCurrentWorkspace);
  const currentScenario = currentWorkspace?.scenarios?.find(
    (s: { id: number; name: string }) => s.id === viewScenarioId
  );

  const folderName = useAppSelector(
    selectFolderName
  );

  const handleSearchKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      console.log(librarySlice.codeSearchString);
      actions.codeSearch({searchString:librarySlice.codeSearchString, folder: folderName, repoId:viewRepoId});
    }
  };

  return (
    <AppBar position="relative" sx={{ borderRadius: 2 }}>
      <Toolbar variant="dense" sx={{ bgcolor: grey[200], borderRadius: 2, display: "flex" }}>
        <Box>
          <TextField
            sx={{ background: "#FFFFFF" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            placeholder="Filter"
            variant="standard"
            value={librarySlice.filterString}
            onChange={(e) => dispatch(setFilterString(e.target.value))}
          ></TextField>
        </Box>
        <Divider orientation="vertical" flexItem sx={{ mx: 1 }}></Divider>
        <Box>
          { /* <Tooltip title="Show archived">
            <Checkbox
              icon={<DeleteIcon />}
              checkedIcon={<DeleteIcon />}
              checked={librarySlice.viewDeleted}
              onClick={(e) =>
                dispatch(setViewDeleted(!librarySlice.viewDeleted))
              }
              onMouseDown={(e) => e.preventDefault()}
            />
            </Tooltip> */}
            { !rolesMode && !reposMode && !scenariosMode && <Tooltip title="Go to the home folder">
              <Button
                onClick={(e) =>
                  actions.changeFolder({id:-1, name:""})
                }
                onMouseDown={(e) => e.preventDefault()}
              >
                <HomeIcon></HomeIcon>
              </Button>
            </Tooltip> }
            { !rolesMode && !reposMode && !scenariosMode && <Tooltip title="Go back one folder">
              <Button
                onClick={(e) => {
                    actions.backFolder()
                  }
                }
                onMouseDown={(e) => e.preventDefault()}
              >
                <BackIcon></BackIcon>
              </Button>
            </Tooltip> }
            { !rolesMode && !reposMode && !scenariosMode && <Tooltip title="Your current folder">
              <Button>{ folders.join(" / ") }</Button>
            </Tooltip> }
            { rolesMode && viewRoleId < 0 && <Tooltip title="Leave roles" onClick={(e) => {
                  dispatch(setRolesMode(false));
                  dispatch(setRoleId(-1));
            }
                }>
              <Button><BackIcon></BackIcon>ROLES</Button>
            </Tooltip> }

            { reposMode && viewRepoId > 0 && <Tooltip title="Leave repo" onClick={(e) => {
                  dispatch(setSearchMode(false));
                  dispatch(setRepoId(-1));
            }
                }>
              <Button><BackIcon></BackIcon>REPO</Button>
            </Tooltip> }

            { scenariosMode && viewScenarioId > 0 && <Tooltip title="Leave scenario" onClick={(e) => {
                  //dispatch(setSearchMode(false));
                  dispatch(setScenarioId(-1));
            }
                }>
              <Button><BackIcon></BackIcon>SCENARIO</Button>
            </Tooltip> }

            { reposMode && viewRepoId < 0 && <Tooltip title="Leave repos" onClick={(e) => {
                  dispatch(setReposMode(false));
                  dispatch(setRepoId(-1));
            }
                }>
              <Button><BackIcon></BackIcon>REPOSITORIES</Button>
            </Tooltip> }

            { scenariosMode && viewScenarioId < 0 && <Tooltip title="Leave scenarios" onClick={(e) => {
                  dispatch(setScenariosMode(false));
                  dispatch(setScenarioId(-1));
            }
                }>
              <Button><BackIcon></BackIcon>SCENARIOS</Button>
            </Tooltip> }

            { rolesMode && viewRoleId > 0 && <Tooltip title="Leave role" onClick={(e) => {
                  dispatch(setRoleId(-1));
            }
                }>
              <Button><BackIcon></BackIcon>ROLE</Button>
            </Tooltip> }
            { !rolesMode && viewRepoId > 0 && (folderName != "/" || librarySlice.searchMode == true) && <Tooltip title="Go back one folder">
              <Button
                onClick={(e) => {
                  //console.log("Before", folderName);

                  if (librarySlice.searchMode) {
                      dispatch(setSearchMode(false));
                  }
                  else {
                    const oneback = folderName.split("/").slice(0, -1).join("/");

                    let newFolder = "/";
                    if (oneback != "") {
                      newFolder = oneback;

                      if (newFolder.charAt(0) == "/" && newFolder.charAt(1) == "/") {
                        newFolder = newFolder.substring(1);
                      }
                    }
                    else {
                      newFolder = "/";
                    }
                    

                    //console.log("After", newFolder);

                    dispatch(setFolderName(newFolder));
                    actions.fileList({id: viewRepoId, folder: newFolder});
                    actions.gitInfo({id:viewRepoId, folder:newFolder, requestType: 'LOGS', count:10});
                  }
                }
                }
                onMouseDown={(e) => e.preventDefault()}
              >
                <BackIcon></BackIcon>
              </Button>
            </Tooltip> }
        </Box>
        { reposMode && viewRepoId > 0 && <Box style={{marginLeft:"20px", flex: 1}}>
          <Divider orientation="vertical" flexItem sx={{ mx: 1 }}></Divider>
          <TextField
            sx={{ background: "#FFFFFF", width: "100%" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            placeholder="Search code..."
            variant="standard"
            value={librarySlice.codeSearchString}
            onChange={(e) => dispatch(setCodeSearchString(e.target.value))}
            onKeyDown={handleSearchKeyDown}
          ></TextField>
        </Box> }
        { reposMode && viewRepoId > 0 && <Tooltip title="Dependency network">
            <IconButton
              sx={{ ml: "auto", color: "black" }}
              onClick={() => {
                // Open is read-only for indexing: show whatever's indexed now.
                // We still poll STATUS until it settles (untilDone only controls the
                // status poll loop — it does NOT enqueue a re-index), so the live feed
                // updates and clears itself when the worker finishes.
                dispatch(openNetwork({ repoId: viewRepoId }));
                actions.loadGraphSettings({ repoId: viewRepoId });
                actions.loadFileGraph({ repoId: viewRepoId });
                actions.pollIndexStatus({ repoId: viewRepoId, untilDone: true });
              }}
              onMouseDown={(e) => e.preventDefault()}
            >
              <AccountTreeIcon />
            </IconButton>
          </Tooltip> }
        { scenariosMode && viewScenarioId > 0 && currentScenario?.name && (
          <Typography variant="subtitle1" sx={{ marginLeft: "auto", fontWeight: 500, color: "black" }}>
            {currentScenario.name}
          </Typography>
        ) }
      </Toolbar>
    </AppBar>
  );
}
